<script setup lang="ts">
import { defineProps,defineEmits } from 'vue'
import { useLanguage } from "../utils/useLanguage";
const { t } = useLanguage();

const props = defineProps({  
        
    status: {
        type: Boolean,
        required: false,
    },
    title: {
        type: String,
        required: true,
    },
    content: {
        type: String,
        required: false,
    },
    count: {
        type: Number,
        required: false,
    },

    
})


</script>
<template>
   <div class="loading fixed flex a-center j-center column" :class="props.status? 'active': ''">
     
    <h2 class="loadingTitle white-1 heading1 fw-semiBold rel p-20 t-center">{{ t(props.title? props.title: 'Just a Moment') }}</h2>
    <p class="white-1 heading3 rel p-20 t-center">{{ props.content? props.content:'' }}</p>
    <p class="heading1 rel p-20 t-center white-1">{{ props.count && props.count >= 0 ? props.count:'' }}</p>


 </div>
</template>

<style scoped>
@import '../assets/css_lib/themimir.css';

.loadingTitle::after{
    content: '...';
    position: absolute;
    /* left: 100%; */
    animation-name: example;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-fill-mode: forwards;
    word-break: keep-all;
}
@keyframes example {
  0%   {content: ''}
  25%  {content: '.'}
  50%  {content: '..'}
  100% {content: '...'}
}
</style>